import { DefaultEffects, Label } from "@fluentui/react";
import { IListaActividadesPorProceso } from "../../../Interfaces/LineaBase/IProcesos";

interface IPlantillaPreViewGrupo {
  data: IListaActividadesPorProceso;
  indice: number;
}
export const PlantillaPreViewActividades = (props: IPlantillaPreViewGrupo) => {
  return (
    <div>
      <div className="ms-Grid" dir="ltr">
        {props.data?.nombre && (
          <div
            id="Cabecerra"
            className="ms-Grid-row"
            style={{
              display: "flex",
              flexDirection: "row",
              height: "auto",
              backgroundColor: "#fde7e9",
              alignItems: "end",
              boxShadow: DefaultEffects.elevation8,
            }}
          >
            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg10">
              <Label
                styles={{
                  root: {
                    color: "Black",
                    fontSize: "12px",
                    padding: "5px",
                    fontWeight: 400,
                    fontFamily: "Monaco, Menlo, Consolas",
                  },
                }}
              >
                {props.data?.nombre}
              </Label>
            </div>
            <div
              className="ms-Grid-col ms-sm12 ms-md6 ms-lg2"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Label
                styles={{
                  root: {
                    color: "White",
                    fontSize: "1px",
                    padding: "5px",
                    fontFamily: "Monaco, Menlo, Consolas",
                  },
                }}
              >
                {props?.indice}
              </Label>
            </div>
          </div>
        )}

        {props.data?.actividades.map((item, i) => (
          <div
            id="registros"
            className="ms-Grid-row"
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "5px",
              height: "30px",
              alignItems: "end",
            }}
          >
            <div
              className="ms-Grid-col ms-sm12 ms-md6 ms-lg12"
              style={{ marginLeft: "10px" }}
            >
              {/* <Label
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  fontFamily: "Segoe UI Web (West European)",
                }}
              >
                {" "}
                {item?.nombre}
              </Label> */}
              <p style={{ fontSize: "12px" }}>{item?.nombre}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
